// Для добавления плашки к секции необходимо указать её id
// Для дочернего элемента секции - страницы указывается url
// --------------------------------------------------------
const betaPages = {
  sections: [],
  pages: [
    // externalAnalysisSection | "Анализ внешки"
    // "/bloggers-posts-selection", // "Отборщик публикаций"
    // "/bloggers_posts_selection", // "Отборщик публикаций"
    // "/bloggers-profiles-selection", // "Отборщик блогеров"
    // "/bloggers_profiles_selection", // "Отборщик блогеров"
    // "/blogger-card", // "Анализ блогера"
    // "/bloggers_trends", // "Тренды"
    // "/blogger-card-new", // Карточка блогера
    // "/blogger_card", // "Анализ блогера"
    "/ai_photo",
  ],
};

const newPages = {
  sections: [
    // "growthLeaders", // Лидеры роста
    // "niches_and_trends", // Ниши и тренды
  ],
  pages: [
    "/analysis-by-seasonality",
    "/spp_by_subjects",
    // growthLeadersSection | "Лидеры роста"
    // "/growth_leaders/products", // "По товарам"
    // "/growth_leaders/brands", // "По товарам"
    // "/growth_leaders/sellers", // "По товарам"
    // "/growth_leaders/categories", // "По товарам"
    // nichesAndTrendsSection | "Ниши и тренды"
    "/keywords-summary-v2", // "Оракул запросов"
    // externalAnalysisSection | "Анализ внешки"
    // "/all-bloggers-search", // "Поиск трафика другие МП"
    // "/bloggers-posts-selection", // "Отборщик публикаций"
    "/bloggers_posts_selection", // "Отборщик публикаций"
    // "/bloggers-profiles-selection", // "Отборщик блогеров"
    "/bloggers_profiles_selection", // "Отборщик блогеров"
    "/bloggers_trends", // "Тренды"
    "/blogger-card-new", // Карточка блогера
    "/blogger_card", // "Анализ блогера"
    // "/blogger-card", // "Анализ блогера"
    // seoSection | "SEO"
    "/keywords-position", // "Индексация запросов"
    "/slices-analytics", // "Аналитика склеек"
    "/calculator?mp=wb", // calculatorSection | "Калькулятор" → Wildberries
    "/calculator?mp=ozon", // calculatorSection | "Калькулятор" → Ozon
    "/promotions", // Управление акциями
    "/clusters_effectiveness", // СПП по предметам
    "/ai_photo",
  ],
};

export { betaPages, newPages };
